import React from 'react'
import Link from 'next/link';

import {
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
    Box
  } from "@mui/material";

import Image from "next/image";
import { useTheme} from  '@/context'
interface AccordionSecondaryProps {
    title: string;
    redirectUrl?: string;
    index: number;
    menuSelected: number | null;
    setMenuSelected: (index: number | null) => void;
    icon: string;
    sidebarOpen: boolean;
    menuColor:string;
    disabled: boolean;
    /** When set, navigates in a new browser tab (e.g. FAQ). */
    openInNewTab?: boolean;
  }

const AccordionSecondary: React.FC<AccordionSecondaryProps> = ({
    title,
    redirectUrl,
    index,
    menuSelected,
    setMenuSelected,
    icon,
    sidebarOpen,
    menuColor, 
    disabled,
    openInNewTab,
  }) => {
    const toggleSelect = () => {
      if (openInNewTab) return;
      if (index === menuSelected) {
        setMenuSelected(null);
      } else {
        setMenuSelected(index);
      }
    };
    const { darkMode } = useTheme();
    const images = darkMode ? require.context(
      "@/assets/images/ideation-phase-images/dark-theme",
      true
    )
    : require.context(
      "@/assets/images/ideation-phase-images",
      true
    );
    let imagePath = images(`./${icon}`);
  
    return (
      <Link
        href={redirectUrl ?? '/'}
        passHref
        key={index}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
      >
        <ListItem
          disablePadding
          onClick={toggleSelect}
          className={`h-[3.25rem] border-l-4 `}
          style={index === menuSelected ? { borderLeftColor: menuColor,background:"white" } : {background:"transparent",borderLeftColor:"transparent"}}
        >
          <ListItemButton sx={{
          paddingTop:".75rem",
          paddingBottom:".75rem",
          paddingLeft:"1.25rem",
          paddingRight:"1.5rem"
        }} disabled={disabled}>
            <Box className='p-1'>
              <Image className="w-[24px] h-[24px]" src={imagePath.default.src} width={500} height={500} alt="sidebar-icon">
              </Image>
            </Box>
            {sidebarOpen && (
              <ListItemText sx={{paddingLeft:"1rem"}}>
              <Typography
              className={` text-[#2E2E2E] dark:text-TJ-white`} 
              sx={{ fontFamily: 'Cerebri Sans',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  textAlign: 'left',
                }}>
                {title}
              </Typography>
              </ListItemText>
            )}
          </ListItemButton>
        </ListItem>
      </Link>
    );
  };

export default AccordionSecondary
